<template>
  <div class="row">
    <div class="col_12">
        <div class="card no_border home_table">
            <div class="card-header">
              <div class="card-title">{{ $t('sidebar.unitManagement.unitManagement') }}</div>
            </div>
            <div class="card-body pl_0 pr_0 mt_10">
              <div class="row">
                <div class="col_2">
                  <div class="form-group ">
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span> {{ filter.subject != '' && subjects.length ? subjects.find(s=> s.id === parseInt(filter.subject)).name : $t('sidebar.subjects.subjects') }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="subjectFilter(subject.id)" v-for="subject in subjects" :key="'subject_'+subject.id"><a role="button">{{ subject.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_1">
                  <div class="form-group ">
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span> {{ filter.grade != '' && grades.length ? grades.find(s=> s.id === parseInt(filter.grade)).name : $t('common.grade') }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="gradeFilter(grade.id)" v-for="grade in grades" :key="'grade'+grade.id"><a role="button">{{ grade.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_1">
                  <div class="form-group ">
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span> {{ filter.semester != '' && semesters.length ? semesters.find(s=> s.id === parseInt(filter.semester)).name : $t('common.semester') }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="semesterFilter(semester.id)" v-for="semester in semesters" :key="'semester'+semester.id"><a role="button">{{ semester.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_2">
                  <div class="form-group ">
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span>{{ filter.area != '' && areas.length ? areas.find(p=>p.id === parseInt(filter.area)).name: $t('sidebar.areas.areas') }}</span>

                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="areaFilter(area.id)"  v-for="area in areas" :key="'subject_'+area.id"><a role="button">{{ area.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_2">
                  <div class="form-group ">
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span>{{ filter.parking != '' && parkings.length ? parkings.find(p=>p.id === parseInt(filter.parking)).name: $t('sidebar.parking.parkings') }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="parkingFilter(parking.id)"  v-for="parking in parkings" :key="'subject_'+parking.id"><a role="button">{{ parking.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col_4">
                  <div class="form-group ">
                    <div class="d_flex_end">
                      <div class="form_row_inline">
                        <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                      </div>
                      <div class="form_row_inline ml_10">
                        <div class="btn btn_common_type_2 mr_10 width_150p" @click="queryParams.page = 1 ; searchCustomer()">{{ $t('common.search') }}</div>
                        <div class="btn btn_secondary width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col_12 ">
                  <div class="separator pl_0 pr_0">
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col_12">
                  <div class="d_flex_btwn pt_20 pb_20">
                    <div class="d_flex_start col_2 pl_0">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span>{{ filter.per_page }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="changePerPageFilter(10)"><a role="button">10</a></li>
                            <li @click="changePerPageFilter(20)"><a role="button">20</a></li>
                            <li @click="changePerPageFilter(50)"><a role="button">50</a></li>
                            <li @click="changePerPageFilter(100)"><a role="button">100</a></li>
                            <li @click="changePerPageFilter(200)"><a role="button">200</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_end col_10 pr_0">
                      <router-link :to="{ name: 'unit_registration_add'}" class="btn btn_transparent">{{ $t('sidebar.unitManagement.createUnit') }}</router-link>
                    </div>
                  </div>
                </div>
              </div>

                <table-component 
                    :columns="columns"
                    :rows="units"
                    :pagination="pagination"
                    @sorting="sorting"
                    :sortable="sortable"
                    @pageChanged="pageChanged">
                    <template #unit_goal="{ row }">
                      <span>{{  unitGoal(row.unit_goal, 40) }}</span>
                    </template>
                    <template #action="{ row }">
                      <div class="d_flex_center table_action_btn">
                        <router-link :to="{name: 'unit_registration_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_blue ml_10">
                          <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                        </router-link>
                        <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                          <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                        </button>
                      </div>
                    </template>
                </table-component>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";

export default {
  components: {TableComponent},
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      units: [],
      subjects: [],
      semesters: [],
      grades: [],
      areas: [],
      parkings: [],
      filter: {
        subject: '',
        grade: '',
        semester: '',
        area: '',
        parking: '',
        per_page: 20
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'unit_name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: this.$t('common.area'),
          field: "area.name",
          sortable: true
        },
        {
          label: this.$t('common.grade'),
          field: "grade.name",
          sortable: true
        },
        {
          label: this.$t('common.semester'),
          field: "semester.name",
          sortable: true
        },
        // {
        //   label: this.$t('common.parking'),
        //   field: "parking.name",
        //   sortable: true
        // },
        {
          label: this.$t('sidebar.unitManagement.unit_name'),
          field: "unit_name",
          sortable: true
        },
        {
          label: this.$t('sidebar.unitManagement.unit_goal'),
          field: "unit_goal",
          sortable: false,
          slot:true,
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
    }
  },
  watch: {
    $route(to, from) {
        if(to.name == from.name && !window._.isEqual(to, from)){
          this.setQueryData(this.getAllQueryParams())
          this.loadData()
        }
      },
  },
  created() {
    const query = this.getAllQueryParams()
    if(query.page){
      this.setQueryData(query)
    }

    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);
    this.axios.get('/grades').then((response) => this.grades = response.data.data);
    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
    this.axios.get('/areas').then((response) => this.areas = response.data.data);
    this.axios.get('/parkings').then((response) => this.parkings = response.data.data);

    this.loadData();
  },
  methods: {
    setQueryData(query){
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        subject: query.subject,
        grade: query.grade,
        semester: query.semester,
        area: query.area,
        parking: query.parking,
        per_page: query.per_page
      }
      this.sortable = {
        order:  query.sort,
        sort: query.sort_order
      }
    },
    resetAll(){
      this.sortable = {
          order: 'created_at',
          sort: 'desc'
      }
      this.filter = {
          subject: '',
          grade: '',
          semester: '',
          area: '',
          parking: '',
          per_page: 20
      }

      this.queryParams = {
          page: 1,
          search: '',
          search_columns: 'unit_name',
          sort: 'created_at',
          sort_order: 'desc',
          per_page: 20
      }

      this.changeRoute();
      this.loadData();
    },
    changePerPageFilter(per_page){
      this.filter.per_page = per_page
      this.changeRoute();
    },
    subjectFilter(id){
      this.filter.subject = id
      this.changeRoute();
    },
    semesterFilter(id){
      this.filter.semester = id
      this.changeRoute()
    },
    gradeFilter(id){
      this.filter.grade = id
      this.changeRoute()
    },
    areaFilter(id){
      this.filter.area = id
      this.changeRoute();
    },
    parkingFilter(id){
      this.filter.parking = id
      this.changeRoute();
    },
    searchCustomer(){
        this.changeRoute();
    },
    sorting({column, order}) {
        this.queryParams.sort = column;
        this.queryParams.sort_order = order;
        this.queryParams.page = 1;
        this.changeRoute()
    },
    pageChanged(page) {
        this.queryParams.page = page;
        this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/units', {
            params: {...this.queryParams, ...this.filter}
        }).then((response) => {
            this.units = response.data.data;
            this.pagination = response.data.meta;
        })
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/units/'+row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            )
          });
        }
      });
    },
    unitGoal(text, length){
      if (text.length > length) {
          return text.substring(0, length)+ "...";
      }else {
          return text;
      }
    }
  }
}
</script>

<style scoped>
  .search_btn{
    padding: 10px 10px 10px 15px;
    margin: 0px 10px 0px 0px;
  }

  .reset_btn{
    padding: 10px 10px 10px 15px;
  }
</style>